<template>
  <transition name="fade">
    <div v-if="active" class="loader-wrapper">
      <div class="loader-backdrop" @click="handleBackdropClick"></div>
      <div class="loader-container">
        <div class="loader">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
        <p v-if="text" class="loader-text">{{ text }}</p>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'MaterialLoading',
  props: {
    active: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: ''
    },
    dismissible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleBackdropClick() {
      if (this.dismissible) {
        this.$emit('close');
      }
    }
  },
  watch: {
    active(newVal) {
      // Prevent body scroll when loader is active
      if (newVal) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    }
  },
  beforeUnmount() {
    // Clean up body scroll lock
    document.body.style.overflow = '';
  }
}
</script>

<style scoped>
/* Fade transition */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* Wrapper - full screen overlay */
.loader-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Semi-transparent backdrop */
.loader-backdrop {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.4);
}

/* Container for loader and text */
.loader-container {
  position: relative;
  z-index: 10000;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

/* Spinner */
.loader {
  display: inline-block;
  width: 80px;
  height: 80px;
  position: relative;
}

.loader div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 64px;
  height: 64px;
  margin: 8px;
  border: 6px solid;
  border-radius: 50%;
  animation: loader 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #333 transparent transparent transparent;
}

.loader div:nth-child(1) {
  animation-delay: -0.45s;
}

.loader div:nth-child(2) {
  animation-delay: -0.3s;
}

.loader div:nth-child(3) {
  animation-delay: -0.15s;
}

@keyframes loader {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Loading text */
.loader-text {
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  margin: 0;
  text-align: center;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .loader {
    width: 60px;
    height: 60px;
  }

  .loader div {
    width: 48px;
    height: 48px;
    margin: 6px;
    border-width: 4px;
  }

  .loader-text {
    font-size: 13px;
  }
}
</style>